import React, { Fragment, Component } from 'react'
import PrevImg from '_src/components/PrevImg/PrevImg'
class LiItem extends Component {
  render () {
    const {Item, children} = this.props
    const { title, content } = Item
    let Node = null
    if (content instanceof Array) {
      Node = content.map((item, index) => {
        return <img key = {index} className = "listItem_img" src = { item } alt = '' onClick={() => this.PrevImg.show(item)} />
      })
      Node = <div className = "listItem_content">{Node}</div>
    }
    else {
      Node = <div className = "listItem_content">{content}</div>
    }
    return (
      <Fragment>
        <div className = "LiItem">
          <p className = "listItem_title">{title}</p>
          {children 
            ? <div className = "listItem_content" style = {{width: '100%'}} >{children}</div> 
            : Node}
        </div>
        <PrevImg ref={el => this.PrevImg = el} />
      </Fragment>
    )
  }
}

export default LiItem